import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { keyframes } from "@emotion/react";
import React from "react";
export const Spinner = React.forwardRef(({ size = "1em", ...rest }, ref) => (_jsx("svg", { ref: ref, viewBox: "0 0 50 50", css: {
        width: size,
        height: size,
        animation: `2s linear infinite none ${keyframes({
            "0%": { transform: "rotate(0)" },
            "100%": { transform: "rotate(360deg)" },
        })}`,
        "& > circle": {
            fill: "none",
            stroke: "currentcolor",
            strokeWidth: 4,
            strokeDasharray: 83,
            strokeLinecap: "round",
        },
    }, ...rest, children: _jsx("circle", { cx: "25", cy: "25", r: "20" }) })));
//# sourceMappingURL=spinner.js.map